var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66667L9.33335 4M1.66669 14.3333L3.92295 14.0827C4.19861 14.052 4.33644 14.0367 4.46527 13.995C4.57957 13.958 4.68834 13.9057 4.78863 13.8396C4.90167 13.765 4.99973 13.667 5.19586 13.4709L13.9999 4.66687C14.7363 3.93047 14.7363 2.7366 13.9999 2.0002C13.2635 1.2638 12.0696 1.2638 11.3332 2.0002L2.52919 10.8042C2.33307 11.0003 2.23501 11.0983 2.16047 11.2114C2.09433 11.3117 2.04205 11.4205 2.00505 11.5348C1.96335 11.6636 1.94803 11.8014 1.9174 12.0771L1.66669 14.3333Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.535bf3c7c6c0dff2a7d303e39298f1df.svg";
export { ForwardRef as ReactComponent };